import onDocumentLoad from './helpers/on-document-load';
import detectBrowser from './helpers/browser-detector';
import UIController from './controllers/ui-controller';

try {
  const s = {
    browser: detectBrowser(),
    pointerTypes: [],
    currentSection: 'home-hero',
  }
  window.s = s;
} catch (e) {
  console.error(e);
}

const VB_APP = function() {

  try {
    UIController.init();
  } catch(e) {
    console.error(e);
  }

};

onDocumentLoad(VB_APP);
